import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../../service/service.js';
import {ElementUtil} from '../../../utils/elementUtil.js';
import {TimeUtil} from '../../../utils/timeUtil.js';
import {ExportUtil} from '../../../utils/exportUtil.js';
import {BaseComponent} from '../../basecomponent.js';


/* global customElements */
class APITrackingGrid extends BaseComponent {
	
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}	
	
	constructor() {
		super();
		
		var trackingGrid = this;
		setTimeout(function(){
			trackingGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var trackingGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							reloadGrid();
						}
					}
				},
				{
					tag: 'vaadin-combo-box',
					label: 'Filter Field',
					itemid: 'filterField',
					'item-value-path': 'code',
					'item-label-path': 'description',					
					value: 'createUser',
					postinit: function (combo) {						
						var filterBy = [{
								code: 'createUser',
								description: 'Username'
							
						}];	
						if (trackingGrid.admin) {
							filterBy.push({
								code: 'companyName',
								description: 'Company Name'

							});
						}							
						combo.items = filterBy;
						combo.required = true;
					}
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter By',
					listeners: {
						input: {
							fn: function() {
								reloadGrid();
							},
							buffer: 2000
					    }
					}
				},	
				{
					tag: 'dl-action-button',
					itemid: 'view',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_TRACKING_MANAGEMENT:READ', 'API_TRACKING:READ'],
					children:[
						ElementUtil.makeIcon('lumo:eye', ' View')
					],
					listeners: {
						click: function() {							
							actionView(grid.selectedItems[0]);
						}
					}
				}
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [				
				{						
					path: 'companyId',
					header: 'Company Id',					
					width: '9em',
					hidden: true
				},
				{						
					path: 'companyName',
					header: 'Company Name',						
					'flex-grow': '1'						
				},
				{						
					path: 'username',
					header: 'Username',						
					width: '5em'						
				},				
				{						
					path: 'trackEventCodeDescription',
					header: 'Event Type',
					'text-align': 'center',
					width: '5em'						
				},
				{						
					path: 'requestMethod',
					header: 'Method',
					'text-align': 'center',
					width: '5em'						
				},				
				{						
					path: 'requestURL',
					header: 'URL',
					'text-align': 'center',
					width: '5em'						
				},	
				{
					path: 'eventDts',
					header: 'Event Date',
					direction: 'desc',
					'text-align': 'center',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);
					},
					width: '5em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'view').disabled = false; 						
					} else {
						ElementUtil.query(toolbar, 'view').disabled = true;
					}	
				}
			}
		});
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					trackingGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						filterField: ElementUtil.query(toolbar, 'filterField').value,
						filterValue: ElementUtil.query(toolbar, 'filterValue').value
					};
					
					Service.getApiService().loadAPIEvents(trackingGrid.currentFilter)
					.then(function(records){
						loadMask.remove();
						grid.activeItem = null;
						grid.items = records.data;
						
						trackingGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();
					});					
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});
		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				actionExport();
			}
		});
		
		var gridLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		trackingGrid.append(gridLayout);
		
		var reloadGrid = function() {
			pagingToolbar.loadPage(1);
		};		
		
		var actionView = function(record) {
			
			var viewWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'View Event',
				icon: 'lumo:eye',
				listeners: {
					ready: function() {
						
						viewWin.show();
						
						var getDetails = function(inputRecord) {
							var date = TimeUtil.parseDate(inputRecord.updateDts);						
							var formatedDate =  TimeUtil.formatDateStandard(date);
							var detailData = [
								{
									key: 'Event Date',
									value: formatedDate
								},
								{
									key: 'Company Id',
									value: inputRecord.companyId
								},
								{
									key: 'Company Name',
									value: inputRecord.companyName
								},
								{
									key: 'Username',
									value: inputRecord.Username
								},
								{
									key: 'Event Type',
									value: inputRecord.trackingCodeDescription
								},
								{
									key: 'Client IP',
									value: inputRecord.clientIP
								},
								{
									key: 'Request Method',
									value: inputRecord.requestMethod
								},
								{
									key: 'URL',
									value: inputRecord.requestURL
								},
								{
									key: 'Request',
									value: inputRecord.request
								},
								{
									key: 'Response',
									value: inputRecord.response
								}
							];
							return detailData;
						};
						
						var details = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								{
									tag: 'div',								
									slot: 'primary',
									children: [
										{
											tag: 'dl-detail-table',
											itemid: 'table',
											style: ''											
										}
									]
								},
								{
									tag: 'dl-nextprev-toolbar',	
									itemid: 'nextPrev',
									slot: 'footer',
									listeners: {
										ready: function(event){
											event.target.updateData(trackingGrid.fullDataSet);
											event.target.setSelectedRecord('trackingId', record.trackingId);
										},
										change: function(event) {
											grid.deselectItem(record);
											grid.selectItem(event.detail.item);
											record = event.detail.item;
											ElementUtil.query(details, 'table').updateDetails(getDetails(record));	
										}										
									}
								}
							]
						});
						viewWin.addToContentElement(details);
						ElementUtil.query(details, 'table').updateDetails(getDetails(record));						
						
					}
				}
			});
			
		};
		
		var actionExport = function() {
			Service.getApiService().exportAPIEvents(trackingGrid.currentFilter);
		};
		
	}
	
};
customElements.define('dl-apitracking-grid', APITrackingGrid);


